import { Select } from 'antd'
import { SelectProps } from 'antd/lib'

import { InventoryDocumentState } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  excludeStates?: InventoryDocumentState[]
} & SelectProps

export const StatesSelect = ({ excludeStates = [], ...props }: Props) => {
  const { t } = useLocales()

  const stateOptions = Object.values(InventoryDocumentState)
    .filter((state) => !excludeStates?.includes(state))
    .map((state) => ({
      label: t(`stock_applications.${state}`),
      value: state
    }))

  return (
    <Select
      mode="multiple"
      options={stateOptions}
      placeholder={t('analysis.status')}
      {...props}
    />
  )
}
